import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { TimetableEntity } from 'src/entities/Timetable.entity';

const BASE_PATH = '/api/v5/master/timetables';

export const TIMETABLES_QUERY_KEY = 'timetables';

type TimetableResponse = { id: number; name: string; course_count: number; created_at: string; updated_at: string };

const deserialize = (data: TimetableResponse): TimetableEntity => ({
  id: data.id,
  name: data.name,
  courseCount: data.course_count,
  createdAt: data.created_at,
  updatedAt: data.updated_at,
});

// ダイヤ一覧はダイヤの作成・名前変更・削除・ダイヤとして保存のときだけ変わるので staleTime を長めに取り、
// window focus での再取得は止める。マウント時の再取得は既定のまま（stale か invalidate 済みのときだけ取り直す）。
// Why not refetchOnMount: false: 一覧を使う画面を全部閉じている間に invalidate しても取り直されず、
// 開き直したときに古い一覧のまま出る（log_web_issues#365 コメント 1）
const TIMETABLES_STALE_TIME_MS = 5 * 60 * 1000;

export const useTimetablesQuery = () => useQuery<TimetableEntity[], Error>({
  queryKey: [TIMETABLES_QUERY_KEY],
  queryFn: async () => {
    const res = await axios.get<TimetableResponse[]>(BASE_PATH);
    return res.data.map(deserialize);
  },
  staleTime: TIMETABLES_STALE_TIME_MS,
  refetchOnWindowFocus: false,
});
